import { render, staticRenderFns } from "./WhatsAppButton.vue?vue&type=template&id=6340b706"
import script from "./WhatsAppButton.vue?vue&type=script&lang=js"
export * from "./WhatsAppButton.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppButton.vue?vue&type=style&index=0&id=6340b706&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports